export default __webpack_public_path__ + "3929a6d078e02948f1c0dce0fdb782a5.png";